export default __webpack_public_path__ + "96e373176b2c288ef095047fe9f8e37a.png";